/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Coinvestment_Emailtemplatedescription3Inputs */

const en_settings_coinvestment_emailtemplatedescription3 = /** @type {(inputs: Settings_Coinvestment_Emailtemplatedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This email template is used for all outgoing messages.`)
};

/**
* | output |
* | --- |
* | "This email template is used for all outgoing messages." |
*
* @param {Settings_Coinvestment_Emailtemplatedescription3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_coinvestment_emailtemplatedescription3 = /** @type {((inputs?: Settings_Coinvestment_Emailtemplatedescription3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Coinvestment_Emailtemplatedescription3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_coinvestment_emailtemplatedescription3(inputs)
});
export { settings_coinvestment_emailtemplatedescription3 as "settings_coInvestment_emailTemplateDescription" }